module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "ch19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch19"
    }
  }, [_c('b', [_vm._v("Music Men")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Ted Nugent has been a Michigan sheriff’s deputy since 1978.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Marilyn Manson’s real name: Brian Hugh Warner.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("When Elvis Presley was three years old, his father altered a check from his employer (raising his pay from $3 to $8). The punishment: the King’s dad spent eight months in the Mississippi State Penitentiary.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Rob Zombie’s first job in entertainment: as a production assistant on the 1980s TV show "), _c('i', [_vm._v("Pee-wee’s Playhouse")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Michael Jackson’s first onstage moonwalk: 1983.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("What does LL Cool J’s name stand for? “Ladies Love Cool James.” (His real name is James Todd Smith.)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("B. B King was playing a concert in 1949 when two men fighting over a woman named Lucille accidentally set fire to the club he was playing in. King risked his life to save his $30 guitar, and when the ordeal was over, he named it— and all his future guitars—after the woman at the center of the ruckus.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b683f7a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter19.vue
// module id = 129
// module chunks = 0